import { el } from '../components/el';
import { Screen } from '../components/screen';

export class Pause extends Screen {
  constructor(parent: HTMLElement, onResume: () => void, onEndShift: () => void, onQuit: () => void) {
    super(parent, 'pause');
    this.panel.append(
      el('h2', '', 'Paused'),
      this.button('Continue', onResume, 'primary'),
      this.button('End shift', onEndShift),
      this.button('Menu', onQuit),
    );
  }
}
